import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StudentProfileAgreementUpload from "./StudentProfileAgreementUpload";
import { Student } from "../../../students/types";
import StudentProfileVirtualAgreementForm from "./StudentProfileVirtualAgreementForm";
import { useAppForm } from "../../../../components/form/useForm";
import AppForm from "../../../../components/form/Form";

interface Props {
  student: Student;
}

const StudentProfileAgreementGuide = ({ student }: Props) => {
  const formHook = useAppForm();
  const { t } = useTranslation();
  const hasESignature = formHook.watch("hasESignature");
  const [isSaving, setSaving] = useState(false);

  const noop = () => {
    // nothing to do
  };

  return (
    <>
      <p>
        <i>{t("my_profile.student.agreement.explanation")}</i>
      </p>
      <AppForm formHook={formHook} onSubmit={noop} isDisabled={isSaving}>
        <AppForm.Group name="hasESignature">
          <p>{t("my_profile.student.agreement.has_esignature")}</p>
          <AppForm.Radio
            name="hasESignature"
            options={[
              { title: "common.yes", value: true },
              { title: "common.no", value: false },
            ]}
          />
        </AppForm.Group>
      </AppForm>
      {hasESignature === false && <StudentProfileAgreementUpload studentId={student.id} onSaving={setSaving} />}
      {hasESignature === true && <StudentProfileVirtualAgreementForm studentId={student.id} onSaving={setSaving} />}
    </>
  );
};

export default StudentProfileAgreementGuide;
